export const complexObjectIcon = {
  name: 'complex-object',
  svg: `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">

<path d="M2 7V2H7V4H4V7H2Z"/>
<path d="M20 4H17V2H22V7H20V4Z"/>
<path d="M20 20V17H22V22H17V20H20Z"/>
<path d="M4 20V17H2V22H7V20H4Z"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.03013 10.1429L11.9994 5L14.9686 10.1429H9.03013ZM12.7417 8.85714L11.9994 7.57143L11.2571 8.85714H12.7417Z"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6 11.8571V17H11.1429V11.8571H6ZM9.42857 13.5714H7.71429V15.2857H9.42857V13.5714Z"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.4286 17C16.8487 17 18 15.8487 18 14.4286C18 13.0084 16.8487 11.8571 15.4286 11.8571C14.0084 11.8571 12.8571 13.0084 12.8571 14.4286C12.8571 15.8487 14.0084 17 15.4286 17ZM15.4286 15.2857C15.902 15.2857 16.2857 14.902 16.2857 14.4286C16.2857 13.9552 15.902 13.5714 15.4286 13.5714C14.9552 13.5714 14.5714 13.9552 14.5714 14.4286C14.5714 14.902 14.9552 15.2857 15.4286 15.2857Z"/>
</svg>`,
};
